import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const MDSelect = (props) => {
  // Accepts props.value or props.defaultValue, falling back to an empty string
  const selectedValue = props.value ?? props.defaultValue ?? '';

  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">{props.label}</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={selectedValue}
        label={props.label}
        onChange={props.onChange}
        MenuProps={{
          style: { zIndex: 35001 }
        }}
        style={{ height: 50 }}
      >
        {props.menu?.map((item, index) => (
          <MenuItem key={index} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MDSelect;